import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from '@material-ui/core';
import { Add } from "@material-ui/icons";
import _ from 'lodash';
import {
    inviteGuestToTargetEmail,
  } from "store/state/guest";
import { getGuestsByDealId, deleteGuestsByDealId, addGuestsToDeal } from "store/state/guest";
import SimpleConfirmDialog from 'components/Global/ConfirmationDialogs/SimpleConfirmDialog';
import SimpleInfoDialog from 'components/Global/ConfirmationDialogs/SimpleInfoDialog';

import { Divider, HeaderSection, SectionTitle, StyledActionButton, styles,SectionFragment } from "../Deal/DealDetailsSections/styles";
import AddGuestModal from './AddGuestModal';
import GuestTable from "./GuestTable";

const GuestViewHeader = ({TitleText, children}) => (<Fragment>
                                                        <HeaderSection container>
                                                            <Grid item xs={6} sm={6} md={6}>
                                                                <SectionTitle className="title-component">{TitleText}{children}</SectionTitle>
                                                            </Grid>
                                                        </HeaderSection>
                                                        {" "}
                                                    </Fragment>);
    

class GuestView extends React.Component {
    state = {
        guestToDelete: {},
        isDeleteModalOpen:false,
        isWarningModalOpen: false,
        isAddNewModalOpen: false
    }

    confirmDeleteGuest = guest => this.setState({ guestToDelete: guest,
                                                  isDeleteModalOpen: guest.canDeleteFromDeal,
                                                  isWarningModalOpen: !guest.canDeleteFromDeal});

    deleteGuest = () => {        
        this.props.deleteGuestsByDealId({id: this.state.guestToDelete.id,
                                         dealId: this.props.dealId,
                                         includeAuxData: false,
                                         accessTypeId: this.props.accessTypeId });
        this.setState({isDeleteModalOpen: false});
    }
    
    openAddNewGuestModal = () => this.setState({isAddNewModalOpen: true})
    
    closeModals = () => this.setState({isDeleteModalOpen: false,
                                            isWarningModalOpen: false,
                                            isAddNewModalOpen: false})
    
    sendInvite = newGuests => {
        const guestIds = newGuests.map(x => x.id);
        const formattedGuests = [];
        newGuests.forEach((item)=>formattedGuests.push({contact:item}));
        this.props.addGuestsToDeal({guestIds: guestIds, dealId: this.props.dealId, accessTypeId: this.props.accessTypeId });        
        this.setState({isAddNewModalOpen: false});
        const type = this.props.dealState[this.props.dealId] ? this.props.dealState[this.props.dealId].dealStatus.value.toLowerCase() : "pipeline";
        this.props.inviteGuestToTargetEmail({
            guest: formattedGuests,
            scope: "deal",
            target: this.props.dealState[this.props.dealId] ? this.props.dealState[this.props.dealId] : this.props.dealState.pipelineActiveDealDetails[this.props.dealId].data,
            targetDealStatus: type,
        });
    }
    
    renderDialogs = () => {
        const {guestToDelete}= this.state;
        return (<Fragment>
                    <SimpleConfirmDialog
                        title="Confirm Delete"
                        message={`You are about to remove ${!guestToDelete ? '' : guestToDelete.firstName } ${!guestToDelete ? '' : guestToDelete.lastName} as a guest from this deal. They will not receive any notification of this change.`}
                        secondaryContent={`Are you sure you want to do this?`}
                        noText="NO"
                        yesText="YES, DELETE"
                        modalOpen={this.state.isDeleteModalOpen}
                        handleNo={this.closeModals}
                        handleYes={this.deleteGuest} />

                    <SimpleInfoDialog 
                        title="Unable to Delete"
                        message={`${!guestToDelete ? '' : guestToDelete.firstName } ${!guestToDelete ? '' : guestToDelete.lastName} is invited as a guest on the ${guestToDelete.isPortfolioGuest ? "Portfolio" : "Group"} level. Access can only be revoked by your Company Admin.`}
                        secondaryContent={`Please contact your Company Admin to complete this action.`}
                        modalOpen={this.state.isWarningModalOpen}
                        handleClose={this.closeModals}
                        handleAccept={this.closeModals}
                        />

                    <AddGuestModal
                        modalOpen={this.state.isAddNewModalOpen}
                        closeModal={this.closeModals}
                        sendInvite={this.sendInvite}
                        currentGuestList={this.props.dealguests}
                        isPortfolio={this.props.isPortfolio}
                        isPipeline={this.props.isPipeline}
                    />
                </Fragment>
            );
    }

    render() {
        const newGuestButton = (<StyledActionButton 
                                    id="newGuestButton"
                                    variant="contained"
                                    onClick={this.openAddNewGuestModal}>
                                    <Add />New Guest</StyledActionButton>);

        return (
            <SectionFragment>
                <Divider><hr /></Divider>
                <Fragment>
                    <Grid container item direction="row" justify="flex-start" alignItems="center" spacing={8}>
                        <GuestTable 
                            isPortfolio={this.props.isPortfolio}
                            isPipeline={this.props.isPipeline}
                            headerComponent={(<GuestViewHeader TitleText="Guests" children={newGuestButton} />)}
                            records={this.props.dealguests}
                            instanceId={this.props.dealId}
                            deleteGuest={this.confirmDeleteGuest}/>
                    </Grid>
                </Fragment>
                {this.renderDialogs()}
            </SectionFragment>
        )};
}

const mapStateToProps = ({ authentication, guest, deal},ownProps) => ({
    authentication,
    dealState: deal,
    dealguests: guest.dealguests ? guest.dealguests[ownProps.dealId] : []
});

export default compose(
                       connect( mapStateToProps,
                                {
                                    getGuestsByDealId,
                                    deleteGuestsByDealId,
                                    addGuestsToDeal,
                                    inviteGuestToTargetEmail,
                                }
                              ),
                              withStyles(styles) 
                       ) (GuestView);